import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateSearchConditionsPutRequestModel, UpdateSearchConditionsPutResponseModel } from "@/features/accounts/shared/services/update-search-conditions-model";

export class UpdateSearchConditionsApi {
  /**
   * 検索条件更新API
   */
  public updateSearchConditions = async (
    param: UpdateSearchConditionsPutRequestModel
  ): Promise<UpdateSearchConditionsPutResponseModel> => {
    const path = `/api/searchconditions`;
    const res = await ApiClient.instance.put<UpdateSearchConditionsPutResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
